import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyViewAlbum = loadable(() => import(/* webpackChunkName: "content/guest/mediacollection/viewalbum" */ './ViewAlbum'), 'ViewAlbum');
